
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.886 9.16a3.107 3.107 0 00-.627-1.104 2.46 2.46 0 00-.942-.647 3.276 3.276 0 00-1.19-.209c-.342 0-.64.041-.894.124a2.35 2.35 0 00-.656.323c-.184.133-.34.276-.466.428a6.378 6.378 0 00-.324.419V7.39H7.2c.013.216.019.634.019 1.256v2.36L7.2 15.21h2.587v-4.376c0-.114.007-.225.02-.333.012-.108.038-.206.076-.295a2.09 2.09 0 01.466-.647c.209-.203.498-.304.865-.304.47 0 .806.162 1.009.485.203.323.304.751.304 1.284v4.186h2.588v-4.49c0-.596-.076-1.116-.229-1.56zM5.23 5.902a1.23 1.23 0 00.381-.951c0-.38-.13-.7-.39-.961-.26-.26-.612-.39-1.056-.39-.444 0-.8.13-1.065.39-.267.26-.4.58-.4.96 0 .369.127.686.38.952.254.266.603.4 1.047.4h.019c.457 0 .818-.134 1.084-.4zM5.288 7.2H2.7v7.82h2.588V7.2zM17.713.124a.41.41 0 01.133.314V17.56a.41.41 0 01-.133.314.458.458 0 01-.323.124H.457a.458.458 0 01-.324-.124A.41.41 0 010 17.56V.438A.41.41 0 01.133.124.458.458 0 01.457 0H17.39c.126 0 .234.041.323.124z"}})])
          )
        }
      }
    